<template>
  <b-card
    no-body
    :img-src="sampleImage"
    class="project-card linked-card"
    :class="{ active: renderProject && renderProject.folder === project.folder }"
  >
    <a @click.prevent="handlePicked(project)" class="card-link"></a>

    <b-btn
      v-if="project.tag === 'uploaded'"
      variant="primary"
      @click.prevent="handlePicked(project)"
      class="btn-overlay btn-overlay--top-left"
    >
      Edit
    </b-btn>
    <b-btn
      v-if="project.tag === 'uploaded'"
      variant="primary"
      @click.prevent="handleRemove(project)"
      class="btn-overlay btn-overlay--top-right"
    >
      <i class="fa fa-trash" />
    </b-btn>
  </b-card>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'project-card',
  props: {
    project: Object,
  },
  computed: {
    ...mapState([
      'renderProject',
    ]),

    sampleImage() {
      return this.project ? `${this.project.getSampleImage()}?clearCache=${+new Date()}` : '';
    },
  },
  methods: {
    handlePicked(project) {
      this.$emit('picked', project);
    },
    handleRemove(project) {
      this.$root.confirm('Are you sure you want to delete this item?').then(() => {
        this.$emit('remove', project);
      });
    },
  },
};
</script>

<style lang="scss">
.project-card {

}
</style>



// WEBPACK FOOTER //
// src/components/ProjectCard.vue